var map = {
	"./logo.svg": 9609,
	"./logo2.svg": 36466,
	"./logoL.svg": 40030,
	"./logo_Uptick_lite_s.svg": 16184,
	"./logo_network.svg": 77490,
	"./logo_on_arbitrum.svg": 45078,
	"./logo_on_arbitrum_w.svg": 29986,
	"./logo_on_bsc.svg": 29575,
	"./logo_on_bsc_w.svg": 57912,
	"./logo_on_polygon.svg": 30363,
	"./logo_on_polygon_w.svg": 15257,
	"./logo_upticktestnet.svg": 47619,
	"./logo_w.svg": 65408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31151;